// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__JpLYJ","author":"Table_author__2Cd2v","authorImage":"Table_authorImage__OdrhC","unreadRow":"Table_unreadRow__3nN7v"};